import Chip, { type ChipProps } from '@mui/material/Chip';

export type T3Status = 'ACTIVE' | 'SUSPENDED' | 'TRIALING' | 'CANCELLED';

const COLOR_BY_STATUS: Record<T3Status, ChipProps['color']> = {
  ACTIVE: 'success',
  SUSPENDED: 'warning',
  TRIALING: 'info',
  CANCELLED: 'default',
};

export interface T3StatusChipProps {
  status: T3Status;
  size?: ChipProps['size'];
}

/**
 * Lifecycle status chip. Colorways resolve through the theme palette, which is
 * built from brand tokens (success/warning/info from tokens.color.*).
 */
export function T3StatusChip({ status, size = 'small' }: T3StatusChipProps) {
  return <Chip label={status} color={COLOR_BY_STATUS[status]} size={size} />;
}
